module.exports = __webpack_public_path__ + "static/game_a_1-6636d970af3932f17dfd254813b9767a.png";